import ActiveTruckIcon from "../icons/ActiveTruckIcon.svg";
import unAssigIcon from "../icons/unAssigIcon.svg";
import calenderIcon from "../icons/calenderIcon.svg";
import canelCircleIcon from "../icons/canelCircleIcon.svg";
import packageIcon from "../icons/packageIcon.svg";
import packageWithXIcon from "../icons/packageWithXIcon.svg";
import threeBoxes from "../icons/threeBoxes.svg";
import completedTruck from "../icons/completedTruck.svg";
import incompleteOrders from "../icons/incompleteOrders.svg"

import delayedDelivery from "../icons/delayedDelivery .svg";
import delayedPickup from "../icons/delayedPickup .svg";
import deliveryFailureOrder from "../icons/deliveryFailureOrder.svg";
import driverChangeRequest from "../icons/driverChangeRequest .svg";
import pendingOrder from "../icons/pendingOrder.svg";
import pendingRescheduledorder from "../icons/pendingRescheduledorder .svg";

const summaryIcons = {
  threeBoxes,
  packageIcon,
  completedTruck,
  ActiveTruckIcon,
  canelCircleIcon,
  calenderIcon,
  packageWithXIcon,
  unAssigIcon,
  delayedDelivery,
  delayedPickup,
  deliveryFailureOrder,
  driverChangeRequest,
  pendingOrder,
  pendingRescheduledorder,
  incompleteOrders
};

export default summaryIcons;
